// extracted by css-extract-rspack-plugin
export default {"UpsellCTALink":"aBdyE","Medium":"RPfNI","Large":"MhOk9"};